import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { SiteFooter } from "@/components/SiteFooter";
import { ArrowLeft, ShieldOff, CheckCircle2 } from "lucide-react";

export default function RetirerConsentement() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault(); setError(""); setLoading(true);
    try { const { data } = await api.post("/consent/withdraw", { email }); setDone(data.count); }
    catch (err) { setError(formatApiError(err.response?.data?.detail) || "Erreur."); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <main className="flex-1 mx-auto max-w-lg w-full px-4 py-10">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-muted-foreground mb-6 hover:text-foreground"><ArrowLeft className="h-4 w-4" /> Accueil</Link>
        <div className="flex items-center gap-2.5 mb-6">
          <div className="h-10 w-10 rounded-xl bg-primary grid place-items-center text-primary-foreground"><ShieldOff className="h-5 w-5" /></div>
          <h1 className="font-heading text-2xl font-bold">Retirer mon consentement</h1>
        </div>
        {done !== null ? (
          <Card className="rounded-2xl p-8 text-center" data-testid="withdraw-success">
            <CheckCircle2 className="h-10 w-10 text-primary mx-auto mb-3" />
            <p className="text-sm text-muted-foreground">Votre demande a été prise en compte. {done > 0 ? "Vous ne recevrez plus d'offres commerciales." : "Aucun consentement actif n'était enregistré pour cette adresse."}</p>
          </Card>
        ) : (
          <Card className="rounded-2xl p-6">
            <p className="text-sm text-muted-foreground mb-4">Indiquez l'adresse e-mail utilisée pour retirer votre consentement à recevoir des offres commerciales. Ce retrait est effectif immédiatement.</p>
            <form onSubmit={submit} className="space-y-4">
              <div className="space-y-1.5"><Label htmlFor="em">E-mail</Label><Input id="em" type="email" required data-testid="withdraw-email" value={email} onChange={(e) => setEmail(e.target.value)} className="h-11 rounded-xl" /></div>
              {error && <p className="text-sm text-destructive">{error}</p>}
              <Button type="submit" disabled={loading} data-testid="withdraw-submit" className="w-full h-12 rounded-2xl">{loading ? "…" : "Retirer mon consentement"}</Button>
            </form>
          </Card>
        )}
      </main>
      <SiteFooter />
    </div>
  );
}
